import { render, staticRenderFns } from "./PhotoManager.vue?vue&type=template&id=2dcfaf2e&scoped=true&"
import script from "./PhotoManager.vue?vue&type=script&lang=js&"
export * from "./PhotoManager.vue?vue&type=script&lang=js&"
import style0 from "./PhotoManager.vue?vue&type=style&index=0&id=2dcfaf2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfaf2e",
  null
  
)

export default component.exports